export const types = [
  { value: 'event', label: 'Событие' },
  { value: 'condition', label: 'Условие' },
  { value: 'delay', label: 'Ожидание' },
  { value: 'offer', label: 'Предложение' },
  { value: 'message', label: 'Сообщение' },
  { value: 'purchase', label: 'Ожидать покупку' },
  { value: 'next', label: 'Следующий цикл' },
  { value: 'stop', label: 'Остановка' },
];
export const tokens = [
  'group',
  'package_name',
  'package_count',
  'remaining',
  'offer_name',
  'offer_count',
  'offer_price',
  'offer_days',
  'offer_until',
];
export const eventLabels = {
  opened: 'Оплаченный пакет открыт',
  exhausted: 'Все публикации использованы',
  expired: 'Срок пакета истёк',
};
export const conditionLabels = {
  no_other_package: 'Нет другого действующего пакета',
  no_reply: 'Клиент ещё не ответил',
  remaining_positive: 'Остались неиспользованные публикации',
  round_first: 'Первая покупка без спецпредложения',
};
export function uid() {
  return crypto.randomUUID();
}
export function cloneSettings(document, inboxId) {
  const result = JSON.parse(JSON.stringify(document));
  const rateIds = Object.fromEntries(result.rates.map(r => [r.id, uid()]));
  const flowIds = Object.fromEntries(result.flows.map(f => [f.id, uid()]));
  result.inbox_id = inboxId;
  result.rates.forEach(r => {
    r.id = rateIds[r.id];
  });
  result.flows.forEach(f => {
    const nodeIds = Object.fromEntries(f.nodes.map(n => [n.id, uid()]));
    f.id = flowIds[f.id];
    f.rate_id = rateIds[f.rate_id];
    f.enabled = false;
    delete f.enabled_since;
    f.nodes.forEach(n => {
      n.id = nodeIds[n.id];
      if (n.data.rate_id) n.data.rate_id = rateIds[n.data.rate_id];
      if (n.data.flow_id) n.data.flow_id = flowIds[n.data.flow_id];
    });
    f.edges.forEach(e => {
      e.id = uid();
      e.source = nodeIds[e.source];
      e.target = nodeIds[e.target];
    });
  });
  return result;
}
export function node(type, x = 140, y = 100) {
  const data = { label: types.find(t => t.value === type)?.label || type };
  if (type === 'event') data.event = 'exhausted';
  if (type === 'condition') data.condition = 'no_other_package';
  if (type === 'delay') data.minutes = 15;
  if (type === 'offer') {
    data.rate_id = '';
    data.hours = 24;
  }
  if (type === 'message')
    data.text =
      'Здравствуйте🌸\nПакет «{package_name}» в группе «{group}» использован. Спасибо, что размещаетесь у нас 🤍\n\nПродолжить размещение? Напишите мне, и я расскажу об условиях.';
  if (type === 'next') data.flow_id = '';
  return { id: uid(), type, position: { x, y }, data };
}
export function edge(source, target, sourceHandle = 'yes') {
  return {
    id: uid(),
    source,
    target,
    sourceHandle,
    targetHandle: 'in',
    markerEnd: 'arrowclosed',
  };
}
export function newFlow(rateId, event = 'exhausted') {
  const a = node('event', 160, 30);
  const b = node('delay', 160, 180);
  const c = node('message', 160, 330);
  const d = node('stop', 160, 480);
  a.data.event = event;
  return {
    id: uid(),
    name: 'Новый сценарий',
    rate_id: rateId,
    enabled: false,
    nodes: [a, b, c, d],
    edges: [edge(a.id, b.id), edge(b.id, c.id), edge(c.id, d.id)],
  };
}
export function title(n) {
  if (!n) return '';
  const generic = types.find(t => t.value === n.type)?.label;
  if (n.data.label && n.data.label !== generic) return n.data.label;
  if (n.type === 'event') return eventLabels[n.data.event];
  if (n.type === 'condition') return conditionLabels[n.data.condition];
  if (n.type === 'delay') return `Подождать ${n.data.minutes || 0} мин.`;
  return n.data.label || types.find(t => t.value === n.type)?.label;
}
export function canConnect(flow, connection) {
  if (
    !connection.source ||
    !connection.target ||
    connection.source === connection.target
  )
    return false;
  if (
    flow.edges.some(
      e =>
        e.source === connection.source &&
        (e.sourceHandle || 'yes') === (connection.sourceHandle || 'yes')
    )
  )
    return false;
  const visiting = [connection.target];
  const seen = new Set();
  while (visiting.length) {
    const id = visiting.pop();
    if (id === connection.source) return false;
    if (!seen.has(id)) {
      seen.add(id);
      flow.edges
        .filter(e => e.source === id)
        .forEach(e => visiting.push(e.target));
    }
  }
  return true;
}
export function serialize(document) {
  const copy = JSON.parse(JSON.stringify(document));
  copy.flows.forEach(f => {
    f.nodes = f.nodes.map(n => ({
      id: n.id,
      type: n.type,
      position: { x: n.position.x, y: n.position.y },
      data: n.data,
    }));
    f.edges = f.edges.map(e => ({
      id: e.id,
      source: e.source,
      target: e.target,
      sourceHandle: e.sourceHandle || 'yes',
      targetHandle: 'in',
      markerEnd: 'arrowclosed',
    }));
  });
  return copy;
}
export function preview(text, document, flow, groupName = 'Название группы') {
  const rate = document.rates.find(r => r.id === flow?.rate_id);
  const offer = document.rates.find(
    r => r.id === flow?.nodes.find(n => n.type === 'offer')?.data.rate_id
  );
  const values = {
    group: groupName,
    package_name: rate?.name || 'Пакет',
    package_count: rate?.count ?? 2,
    remaining: 1,
    offer_name: offer?.name || 'Название предложения',
    offer_count: offer?.count ?? '…',
    offer_price: offer ? offer.amount / 100 : '…',
    offer_days: offer?.days ?? '…',
    offer_until: 'дата и время окончания',
  };
  return text.replace(/\{([^{}]+)\}/g, (all, key) => values[key] ?? all);
}
const errors = {
  next_tariff_mismatch:
    'Следующий цикл должен вести во включённый сценарий тарифа из предложения, после блока покупки.',
  offer_before_message:
    'Перед сообщением с условиями предложения добавьте блок «Предложение» на каждой ветке.',
  purchase_without_offer: 'Перед ожиданием покупки нужен блок предложения.',
  revision_conflict:
    'Настройки изменены в другом окне. Обновите данные перед сохранением.',
  private_dialog_not_found:
    'Личная переписка этого Telegram ID с выбранным отправителем не найдена. Сначала проверьте диалог и ID.',
  rate_disabled:
    'Выбранный тариф выключен или не подходит для платной покупки.',
  offer_disabled: 'Для включения сценария сначала включите предлагаемый тариф.',
  invalid_next_flow: 'В блоке следующего цикла выберите существующий сценарий.',
  ambiguous_flow:
    'Для одного тарифа и события включено несколько сценариев. Оставьте один.',
  graph_cycle:
    'В схеме есть замкнутая петля. Повторный цикл задайте блоком «Следующий цикл» после покупки.',
  unconnected_blocks:
    'В схеме есть блоки, не связанные с событием. Соедините или удалите их.',
  missing_transition: 'Не у каждого блока есть следующий шаг.',
  missing_no_branch: 'В условии соедините обе ветки: «Да» и «Нет».',
  one_event_required:
    'У сценария должен быть ровно один начальный блок события.',
  unknown_token:
    'В сообщении есть неизвестная подстановка. Используйте предложенные поля.',
  overlapping_permission:
    'У клиента уже есть пакет с пересекающимся сроком. Проверьте действующее размещение.',
  payment_confirmation_required: 'Подтвердите, что оплата проверена.',
  offer_expired: 'Срок спецпредложения закончился или оно уже использовано.',
  request_key_conflict:
    'Ключ операции относится к другой покупке. Проверьте результат предыдущей операции.',
};
export function errorText(error) {
  const status = error?.response?.status;
  const code = error?.response?.data?.error;
  if (status === 403)
    return 'Раздел доступен только администратору рабочей области.';
  if (status === 404) return 'Автоматизация или выбранная группа недоступна.';
  return (
    errors[code] ||
    (code
      ? 'Проверьте заполнение тарифов, сообщений и соединений блоков.'
      : 'Нет подтверждения от сервера. Проверьте соединение и сохранённые данные.')
  );
}
